export default "__VITE_ASSET__Dyeb0K3K__"